"use client";

import Icon from "@/components/Icon";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useBookmark } from "../hooks/useBookmark";

export const BookmarkButton = ({
	itemId,
	className,
	size = 16,
	variant = "outline",
}: {
	itemId: string;
	className?: string;
	size?: number;
	variant?: "outline" | "ghost";
}) => {
	const { isBookmarked, toggleBookmark } = useBookmark(itemId);

	return (
		<Button
			onClick={toggleBookmark}
			variant={variant}
			size="icon"
			className={cn(
				"rounded-md transition-colors hover:bg-gray-100",
				"text-gray-500 hover:text-gray-700",
				{
					"text-yellow-600 hover:text-yellow-700": isBookmarked,
				},
				className,
			)}
			title={isBookmarked ? "Remove bookmark" : "Bookmark this post"}
		>
			<Icon name={isBookmarked ? "Bookmark" : "BookmarkPlus"} size={size} />
		</Button>
	);
};
